<template>
  <div class="h-100 w-100 p-2" @click="select()" :class="[colour]">
    <div class="w-100 h-100" :class="{ selected: isSelected }">
    </div>
  </div>
</template>

<script>
export default {
  name: 'GameSelections',
  props: ['colour', 'position', 'imageQuad'],
  computed: {
    isSelected () {
      return this.imageQuad === this.position
    }
  },
  methods: {
    select () {
      this.$emit('update:imageQuad', this.position)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.white {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 6px 6px 8px 0 rgba(0, 0, 0, 0.3);
}
.blue {
  background-color: rgb(0, 75, 141);
  border-radius: 10px;
  box-shadow: 6px 6px 8px 0 rgba(0, 0, 0, 0.3);
}
.grey {
  background-color: #58585a;
  border-radius: 10px;
  box-shadow: 6px 6px 8px 0 rgba(0, 0, 0, 0.3);
}
.gold {
  background-color: rgb(185, 140, 96);
  border-radius: 10px;
  box-shadow: 6px 6px 8px 0 rgba(0, 0, 0, 0.3);
}
.selected{
  border: 2px solid #fff;
  border-radius: 10px;
}
.white .selected {
  border: 2px solid rgb(0, 75, 141);
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/GameSelections.vue